import React from "react";
import { withRouter } from "react-router-dom";

import Text from "components/common/Text";
// import Link from "components/common/Link";
import Grid from "components/common/Grid";
import Stack from "components/common/Stack";
// import Loader from "components/common/Loader";
import { config } from "config";

import JarvisCard from "components/JarvisCard";
import SIPForm from "components/InvestMore/SIPForm";
import InvestMoreInfo from "components/InvestMore/InvestMoreInfo";
import LumpsumForm from "components/InvestMore/LumpsumForm";
import PricingDetails from "components/InvestMore/PricingDetails";

import PrimeInvestMoreRebalanceContainer from "./PrimeInvestMoreRebalance/PrimeInvestMoreRebalance";
import Box from "components/common/Box";
import PlanPayment from "containers/PlanPayment";

// tracker
import { tracker } from "library/tracker";

// import ArrowIcon from "@mui/icons-material/ArrowForwardOutlined";
// import HistoryIcon from "@mui/icons-material/HistoryOutlined";

import { validationHelper } from "helper/validation";
import { dateTimeHelper } from "helper/dateTime";
import JarvisDialog from "components/JarvisDialog";
import { jarvisPrimeInvestMoreApis } from "stores/jarvisPrime/jarvisPrimeInvestMore/jarvisPrimeInvestMoreApis";
import { jarvisPrimeInvestMoreParsers } from "stores/jarvisPrime/jarvisPrimeInvestMore/jarvisPrimeInvestMoreParsers";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { commonActions } from "stores/common/commonActions";
import { jarvisPrimeInvestMoreActions } from "stores/jarvisPrime/jarvisPrimeInvestMore/jarvisPrimeInvestMoreActions";
import { masterActions } from "stores/master/masterActions";
import { localStore } from "stores/localStorage";

const screenTypes = {
  INVESTMENT_FORM: "INVESTMENT_FORM",
  INVESTMENT_PAYMENT: "INVESTMENT_PAYMENT",
  INVESTMENT_REBALANCE: "INVESTMENT_REBALANCE",
  INVEST_MORE_PAYMENT: "INVEST_MORE_PAYMENT",
};

class PrimeInvestMoreContainer extends React.Component {
  inprogressTimer = 0;

  constructor(props) {
    super(props);
    this.state = {
      activeScreenType: screenTypes.INVESTMENT_FORM,
      investmentPricingData: {},
      formData: {
        investmentAmount: null,
        sipDate: new Date(),
      },
      formError: {
        investmentAmount: "",
      },
      isLoadingPricingData: false,
      inprogressTimerStarted: false,
      submitInvestMore: false,
      confirmDialogOpen: false,
      investMoreFees: null,
      planId: null,
      customerValueAddedPlanId: null,
    };
  }

  componentDidMount() {
    this.props.getInvestmentStocksAction();
    // if (
    //   !Object.keys(this.props.investmentStocksData).length ||
    //   _get(this.props.location, "state.paymentStatus", "") === "SUCCEED" ||
    //   ["Completed", "NotConfirmed"].includes(
    //     _get(this.props.location, "state.brokerStatus", "")
    //   )
    // ) {
    // }
  }

  componentDidUpdate() {
    clearInterval(this.timerInProgress);

    // call api every 5 sec until it changes from inprogress to stocks
    if (
      this.props.investmentStocksData &&
      this.props.investmentStocksData.investMoreCase === 2
    ) {
      if (!this.state.inprogressTimerStarted) {
        this.setState({ inprogressTimerStarted: true });
      }
      this.timerInProgress = setInterval(() => {
        this.props.getInvestmentStocksAction();
      }, 8000);
    }
  }

  componentWillUnmount() {
    clearInterval(this.timerInProgress);
  }

  handleInputChange = ({ name, value }) => {
    if (name === "investmentAmount" && isNaN(value)) {
      return;
    }
    const { formData } = this.state;
    formData[name] = value;
    this.setState({ formData });
  };

  handleLumpsumValidation = () => {
    const { formData, formError } = this.state;

    const investmentAmountValidation = validationHelper.minInvestment(
      formData.investmentAmount,
      this.props.minInvestmentAmount,
    );
    formError.investmentAmount = investmentAmountValidation.message;

    this.setState({ formError });
    return investmentAmountValidation.isValid;
  };

  handleLumpsumSubmit = () => {
    //NOTE : event_tracker => investMore
    //tracker.investMore.investMoreFeesCalculation();
    if (!this.handleLumpsumValidation()) {
      return;
    }

    this.setState({ confirmDialogOpen: true });
  };

  handleConfirmClose = () => {
    this.setState({ confirmDialogOpen: false });
  };

  handleConfirmSubmit = async () => {
    const { formData } = this.state;
    this.setState({ submitInvestMore: true });

    try {
      const res = await jarvisPrimeInvestMoreApis.submitInvestMore({
        investmentAmount: formData.investmentAmount,
      });
      const payload =
        jarvisPrimeInvestMoreParsers.submitInvestMoreResponse(res);
      this.setState({
        submitInvestMore: false,
        activeScreenType: screenTypes.INVEST_MORE_PAYMENT,
        investMoreFees: payload.fees,
        planId: payload.planId,
        customerValueAddedPlanId: payload.id,
      });
      localStore.setActiveProduct(config.productCodes.PRIME);
    } catch (error) {
      //NOTE : event_tracker => investMore
      tracker.investMore.investMoreFeesCalculationFailed({
        error_msg: error.message,
      });
      // handle error
    } finally {
      this.setState({
        submitInvestMore: false,
        confirmDialogOpen: false,
      });
    }
  };

  handleSIPValidation = () => {
    const { formError } = this.state;

    this.setState({ formError });
    return true;
  };

  handleSIPSubmit = async () => {
    if (!this.handleSIPValidation()) {
      return;
    }

    // const { formData } = this.state;
    this.setState({ isLoadingPricingData: true });

    try {
      // handle api call
    } catch (error) {
      // handle error
    } finally {
      this.setState({ isLoadingPricingData: false });
    }
  };

  handlePaymentBackClick = () => {
    this.setState({
      activeScreenType: screenTypes.INVESTMENT_FORM,
      investmentPricingData: {},
    });
  };

  handlePaymentContinueClick = () => {
    const { formData } = this.state;

    const stateParams = {
      paymentType: "additionalInvestment",
      paymentAmount: formData.investmentAmount,
      returnURI: this.props.location.pathname,
      // returnURIDelaySecond: 25000,
    };

    if (this.props.investmentType === "SIP") {
      stateParams["additionalInvestmentType"] = "sip";
      stateParams["sipDate"] = dateTimeHelper.sipDate(formData.sipDate);
    } else {
      stateParams["additionalInvestmentType"] = "lumpsum";
    }

    //NOTE event_tracker => investMore
    tracker.investMore.investMoreProceedtoPay();
    this.props.history.push({
      pathname: "/customer/payment",
      state: stateParams,
    });
  };

  handlePaymentClick = (paymentData, isOnetime) => {
    const { planId, customerValueAddedPlanId } = this.state;
    localStore.resetPaymentInitiated();

    if (!customerValueAddedPlanId) {
      console.error("Investment ID (customerValueAddedPlanId) is missing!");
      return;
    }

    this.props.history.push({
      pathname: isOnetime ? "/customer/onetime-payment" : "/customer/payment",
      state: {
        productCode: "PRIME",
        planId: planId,
        paymentMethod: paymentData.paymentMethod,
        paymentMethodOption: paymentData.paymentMethodOption,
        paymentType: "INITIAL",
        transactionType: "INVEST_MORE",
        customerValueAddedPlanId: customerValueAddedPlanId,
        offerCode: paymentData.offerCode,
        paymentDetails: {
          authType: paymentData.authType,
          accountNumber: paymentData.accountNumber,
          accountType: paymentData.accountType,
          accountHolderName: paymentData.accountHolderName,
          ifscCode: paymentData.ifscCode,
        },
      },
    });
  };

  render() {
    const {
      formData,
      formError,
      activeScreenType,
      investmentPricingData,
      isLoadingPricingData,
      inprogressTimerStarted,
      submitInvestMore,
    } = this.state;
    const {
      minInvestmentAmount,
      investmentType,
      isInvestmentStocksLoading,
      investmentStocksData,
      profileData,
      brokersList,
      isBrokersListLoading,
      isBrokersListInitialCalled,
      getBrokersAction,
      pendingCallAction,
    } = this.props;

    // show loader when broker list calling
    if (isInvestmentStocksLoading && !inprogressTimerStarted) {
      return (
        <JarvisCard
          sx={{
            maxHeight: 420,
            pb: 10,
            position: "relative",
            overflow: "hidden",
          }}
        >
          {/* <Loader
            position="absolute"
            loading={true}
          /> */}
          <Box
            sx={{
              minHeight: { xs: "100%", md: "50vh" },
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src="/images/portfolio-loader-video.gif"
              alt="loader"
              style={{ maxWidth: "320px", borderRadius: 3 }}
            />
          </Box>
        </JarvisCard>
      );
    }
    if (submitInvestMore) {
      return (
        <JarvisCard
          sx={{
            maxHeight: 420,
            pb: 10,
            position: "relative",
            overflow: "hidden",
          }}
        >
          {/* <Loader
            position="absolute"
            loading={true}
          /> */}
          <Box
            sx={{
              minHeight: { xs: "100%", md: "50vh" },
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src="/images/portfolio-loader-video.gif"
              alt="loader"
              style={{ maxWidth: "320px", borderRadius: 3 }}
            />
          </Box>
        </JarvisCard>
      );
    }

    return (
      <>
        {/* NOTE:
                investMoreCase 0:
                User is allowed for additional investment */}

        {investmentStocksData.investMoreCase === 0 ? (
          <JarvisCard
            sx={{
              height: "100%",
              px: { xs: 0, md: 4 },
              py: { xs: 1.5, md: 3 },
            }}
          >
            {activeScreenType === screenTypes.INVESTMENT_PAYMENT ? (
              <PricingDetails
                onBackClick={this.handlePaymentBackClick}
                onContinueClick={this.handlePaymentContinueClick}
              />
            ) : null}

            {activeScreenType === screenTypes.INVEST_MORE_PAYMENT ? (
              <PlanPayment
                key={this.state.planId}
                paymentType="INITIAL"
                productCode="PRIME"
                investMoreFees={this.state.investMoreFees}
                customerValueAddedPlanId={this.state.customerValueAddedPlanId}
                onboardingPlanId={this.state.planId}
                onPayNowClick={this.handlePaymentClick}
                byPassRecurringPayment={true}
                oneTimePayment={true}
                navigatePreviousScreen={() =>
                  this.setState({
                    activeScreenType: screenTypes.INVESTMENT_FORM,
                  })
                }
              />
            ) : null}

            {activeScreenType === screenTypes.INVESTMENT_FORM ? (
              <>
                <Grid container>
                  <Grid item lg={7}>
                    <Stack sx={{ pr: { xs: 0, md: 5 } }}>
                      {investmentType === "LUMPSUM" ? (
                        <LumpsumForm
                          onChange={this.handleInputChange}
                          onSubmit={this.handleLumpsumSubmit}
                          formError={formError}
                          formData={formData}
                          minInvestment={minInvestmentAmount}
                          isLoading={isLoadingPricingData}
                        />
                      ) : (
                        <SIPForm
                          onChange={this.handleInputChange}
                          onSubmit={this.handleSIPSubmit}
                          formError={formError}
                          formData={formData}
                          minInvestment={5000}
                          isLoading={isLoadingPricingData}
                        />
                      )}

                      {/* NOTE: Temprary hide history button */}
                      {/* <Stack
                      direction="row"
                      spacing={1}
                      alignItems="center"
                      sx={{
                        mb: 2,
                        display: {
                          xs: "none",
                          md: "flex",
                        },
                      }}
                    >
                      <HistoryIcon
                        sx={{
                          fontSize: 26,
                          color: "primary.main",
                        }}
                      />
                      <Link
                        href="/customer/profile"
                        variant="subtitle2"
                        sx={{ fontWeight: "medium" }}
                      >
                        Investment History
                        <ArrowIcon
                          sx={{
                            fontSize: 16,
                            ml: 1,
                            color: "primary.main",
                          }}
                        />
                      </Link>
                    </Stack> */}
                    </Stack>
                  </Grid>

                  <Grid item lg={5}>
                    <InvestMoreInfo minimumAmount={minInvestmentAmount} />
                  </Grid>
                </Grid>
                {/* Modal: Confirmation of Plan Selection */}
                <JarvisDialog
                  open={this.state.confirmDialogOpen}
                  onClose={this.handleConfirmClose}
                  onConfirm={this.handleConfirmSubmit}
                  title={"Confirmation Required"}
                  content="Your portfolio will be rebalanced. Do you want to continue?"
                />
              </>
            ) : null}
          </JarvisCard>
        ) : null}

        {/*
                    NOTE:
                        investMoreCase 1:
                        User has already done an investment and can not be done for 7 days
                */}
        {investmentStocksData.investMoreCase === 1 ? (
          <JarvisCard
            sx={{
              maxHeight: 420,
              pb: 10,
              background: config.isMobileApp ? "unset" : "#fff",
            }}
          >
            <Stack
              alignItems="center"
              justifyContent="center"
              sx={{ flex: 1, textAlign: "center" }}
              spacing={2}
            >
              <Text variant="subtitle1"> Awesome! </Text>
              <Text variant="small" sx={{ maxWidth: "550px" }}>
                {/* You Have Already Made Investment Few Day Before.
                <br />
                You Can't Add More Invest Before{" "}
                {investmentStocksData.nextInvestmentDate
                  ? dateTimeHelper.displayDate(
                      investmentStocksData.nextInvestmentDate
                    )
                  : "Completing 7 Days Period."}
                . */}
                {investmentStocksData.investMoreMsg
                  ? investmentStocksData.investMoreMsg
                  : "You can certainly invest more funds. However, if you have just invested / rebalanced your portfolio, you will have to wait for 7 days to invest more."}
              </Text>
            </Stack>
          </JarvisCard>
        ) : null}

        {/*
                    NOTE:
                        investMoreCase 2:
                        User has completed payment recently and rebalance is not completed yet
                */}
        {investmentStocksData.investMoreCase === 2 ? (
          <JarvisCard
            sx={{
              maxHeight: 420,
              background: config.isMobileApp ? "unset" : "#fff",
            }}
          >
            <Stack
              alignItems="center"
              justifyContent="center"
              sx={{
                flex: 1,
                textAlign: "center",
                minHeight: { xs: "100%", md: "50vh" },
              }}
              spacing={2}
            >
              <img src="/images/portfolio-loader-video.gif" alt="portfolio" />
            </Stack>
          </JarvisCard>
        ) : null}

        {investmentStocksData.investMoreCase === 3 ||
        activeScreenType === screenTypes.INVESTMENT_REBALANCE ? (
          <PrimeInvestMoreRebalanceContainer
            investmentStocksData={investmentStocksData}
            profileData={profileData}
            isBrokersListInitialCalled={isBrokersListInitialCalled}
            brokersList={brokersList}
            getBrokersAction={getBrokersAction}
            isBrokersListLoading={isBrokersListLoading}
            pendingCallAction={pendingCallAction}
          />
        ) : null}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    minInvestmentAmount:
      state.jarvisPrime.primeOnboarding.minimumAdditionalInvestAmount,
    investmentStocksData: state.jarvisPrime.PrimeInvestMore.investmentStocks,
    isInvestmentStocksLoading:
      state.jarvisPrime.PrimeInvestMore.loading.investmentStocks,
    profileData: state.customer.profile,

    brokersList: state.common.brokers,
    isBrokersListLoading: state.common.loading.brokers,
    isBrokersListInitialCalled: state.common.initialCalled.brokers,
    centrumReferalURL: state.common.featureConfig.centrumReferalURL,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getInvestmentStocksAction:
        jarvisPrimeInvestMoreActions.getInvestmentStocks,
      getBrokersAction: commonActions.getBrokers,
      pendingCallAction: masterActions.getPendingCall,
    },
    dispatch,
  );

export default withRouter(PrimeInvestMoreContainer);
